import React from 'react'
import { Button as HdsButton, ButtonList as HdsButtonList } from '@postenbring/hedwig-react'

export const ButtonList = ({ listStyle = 'default', usePrimary, buttons }) => {
    return (
        <HdsButtonList variant={listStyle} className='hds-mb-24-32'>
            {buttons.map((button, index) => (
                <HdsButton
                    asChild
                    variant={ index === 0 && usePrimary ? "primary" : "secondary" }
                    fullWidth={listStyle === "stretched"}
                >
                    <a href={button.buttonLink} target={button.buttonTarget}>{button.linkText}</a>
                </HdsButton>
            ))}

        </HdsButtonList>

    )
}
